'use client'
import {
  Col,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@repo/ui/components'
import { BalanceAssetDetails } from './balance-asset.details'
import { BalanceAssetHistory } from './balance-asset.history'
import { BalanceProjectHistory } from '../project/balance-project.history'
import { useTranslate } from '@repo/shared/hooks'

export const BalanceAssetContainer = ({ assetId }: { assetId: string }) => {
  const { t } = useTranslate()
  const tabs = [
    {
      value: 'deposit',
      label: t('walletPage_history_deposit'),
    },
    {
      value: 'sell',
      label: t('walletPage_history_sell'),
    },
  ]
  return (
    <Col className='min-h-screen items-start mb-8xl md:mb-3'>
      <BalanceAssetDetails assetId={assetId} />

      <Tabs
        defaultValue='deposit'
        color='base'
        size='md'
        scrollable={false}
        className='w-full mt-md'
      >
        <TabsList className='w-full md:w-fit'>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent key={tab.value} value={tab.value} className='w-full'>
            {tab.value === 'deposit' && <BalanceAssetHistory />}
            {tab.value === 'sell' && (
              <BalanceProjectHistory projectId={assetId} />
            )}
          </TabsContent>
        ))}
      </Tabs>
    </Col>
  )
}
